import { render } from "./view-expenses.vue?vue&type=template&id=3af125cf&scoped=true"
import script from "./view-expenses.vue?vue&type=script&lang=js"
export * from "./view-expenses.vue?vue&type=script&lang=js"

import "./view-expenses.vue?vue&type=style&index=0&id=3af125cf&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af125cf"]])

export default __exports__